import SmoothScroll from 'smooth-scroll';

const smoothScroll = () => {

  setTimeout(() => {

    // eslint-disable-next-line no-unused-vars
    const scroll = new SmoothScroll('a[href*="#"][data-scroll]', {
      speed: 500,
      updateURL: false,
      header: '#header',
      offset: 20
    });

    // Scroll to hash if present on load
    const hash = window.location.hash;
    if (hash) {
      let target = document.querySelector(hash);

      // Wenn das Ziel existiert und keine Section ist → nächste Section suchen
      if (target && target.tagName.toLowerCase() !== 'section') {
        const closestSection = target.closest('section');
        if (closestSection) {
          target = closestSection;
        }
      }

      // Falls ein (angepasstes) Ziel gefunden wurde → smooth scroll
      if (target) {
        scroll.animateScroll(target);
      }
    }

  }, 250)

};

smoothScroll();
